'use client';

import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface MetricsViewActions {
  loading: boolean;
  refresh: () => void;
}

export function MetricsRefreshControls({
  label,
  checked,
  onCheckedChange,
  loading,
  onRefresh,
  disabled = false,
  actionLabel = 'Refresh',
  loadingLabel = 'Refreshing…',
}: {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  loading: boolean;
  onRefresh: () => void;
  disabled?: boolean;
  actionLabel?: string;
  loadingLabel?: string;
}) {
  return (
    <div
      role="group"
      aria-label={`${label} controls`}
      className="flex h-9 items-center rounded-md border bg-background p-0.5"
    >
      <label className={cn('flex h-7 items-center gap-2 px-1.5 text-xs', disabled && 'text-muted-foreground')}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onCheckedChange(event.target.checked)}
        />
        {label}
      </label>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 rounded border-l"
        onClick={onRefresh}
        disabled={loading || disabled}
      >
        <RefreshCw className={cn('mr-1.5 h-3.5 w-3.5', loading && 'animate-spin')} />
        <span aria-live="polite">{loading ? loadingLabel : actionLabel}</span>
      </Button>
    </div>
  );
}
